import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initializeUcanAppContext } from "@/lib/ucanApp";

// Prevent Google Maps IntersectionObserver errors from crashing the app
window.addEventListener('error', (e) => {
  if (e.message?.includes('IntersectionObserver')) {
    e.preventDefault();
  }
});

initializeUcanAppContext();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
